'use strict';

var _vuePagination = require('vue-pagination-2');

var _vueMultiselect = require('vue-multiselect');

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vueDirectiveTooltip = require('vue-directive-tooltip');

var _vueDirectiveTooltip2 = _interopRequireDefault(_vueDirectiveTooltip);

require('vue-directive-tooltip/css/index.css');

var _contextualMenu = require('../template/contextualMenu');

var _contextualMenu2 = _interopRequireDefault(_contextualMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueDirectiveTooltip2.default, {
  placement: 'top',
  delay: 200,
  class: 'tooltip-header',
  triggers: ['hover'],
  offset: 0

});

module.exports = {
  'xmenu': _contextualMenu2.default,
  Pagination: _vuePagination.Pagination,
  'v-multi-select': _vueMultiselect2.default
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/mixins/components.js